module.exports = __webpack_public_path__ + "img/hourglass.26cad0d9.png";